import React, { Component } from 'react';
import { OutlinedInput, InputLabel, FormControl, Select, FormHelperText } from "@material-ui/core";

export default class BetterSelect extends Component {
	render() {
		const shrink =
			this.props.shrink !== undefined
				? this.props.shrink
				: (this.props.InputLabelProps && this.props.InputLabelProps.shrink !== undefined)
					? this.props.InputLabelProps.shrink
					: Boolean(
						this.props.todosOption ||
						(this.props.value !== undefined && this.props.value !== null && this.props.value !== '')
					);

		return (
			<FormControl variant="outlined" className="MuiFormControl-marginNormal" error={this.props.error ? this.props.error : false}>
				<InputLabel shrink={shrink}>{this.props.label}</InputLabel>

				<Select native value={this.props.value} name={this.props.name ? this.props.name : ""} disabled={this.props.disabled}
					onBlur={this.props.onBlur ? this.props.onBlur : null} onChange={this.props.onChange}
					input={<OutlinedInput notched={shrink} name={this.props.name ? this.props.name : ""} labelWidth={this.props.labelWidth} />}>

					{this.props.blankOption ?
						<option />
						: null
					}

					{this.props.todosOption ?
						<option label="Todos" value="-1"></option>
						: null
					}

					{this.props.children}
				</Select>

				{this.props.helperText ?
					<FormHelperText>{this.props.helperText}</FormHelperText>
					: null
				}
			</FormControl>
		);
	}
}